import { render, staticRenderFns } from "./PatentSearchDatabaseList.vue?vue&type=template&id=bb41d69a&"
import script from "./PatentSearchDatabaseList.vue?vue&type=script&lang=js&"
export * from "./PatentSearchDatabaseList.vue?vue&type=script&lang=js&"
import style0 from "./PatentSearchDatabaseList.vue?vue&type=style&index=0&id=bb41d69a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports